export { default as DownloadSolidIcon } from './DownloadSolidIcon';
